/* eslint-disable */
const listeners = new Set();

export function notifyReady() {
    const msg = JSON.stringify({ source: "web", type: "web_ready" });
    if (window?.ReactNativeWebView?.postMessage) window.ReactNativeWebView.postMessage(msg);
    else console.log("[bridge] postMessage (dev)", msg);
}

export function addAppMessageListener(fn) {
    listeners.add(fn);
    return () => listeners.delete(fn);
}

function emitToListeners(e) {
    try {
        const data = JSON.parse(e?.data);
        listeners.forEach((fn) => fn(data));
    } catch { }
}

window.addEventListener("message", emitToListeners);
// ✅ Android WebView에서 document로 들어오는 케이스 커버
document.addEventListener("message", emitToListeners);

export default { notifyReady, addAppMessageListener };
